//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action$Type } from '../genericFlowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    resultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    vendors: [],
    vendorsLoaded: false
}

//In use : actionTypes.URANUS_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const updateFormError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedVendors=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}

const headerActionsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.URANUS_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.URANUS_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.URANUS_INV_SUBMIT_ERROR]: headerActionsError,
    [actionTypes.URANUS_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.URANUS_EDIT_VERIFY_FORM_DATA_ERROR]: headerActionsError,
    [actionTypes.URANUS_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_URANUS_VENDORS_SUCCESS]: refreshedVendors,
    [actionTypes.REFRESH_URANUS_VENDORS_ERROR]: headerActionsError
});


// WEBPACK FOOTER //
// ./src/redux/uranus/reducer.js